/* eslint dot-notation:0 */
(function(angular) {
    'use strict';

    angular.module('um.categories').controller('categories.controller', categoriesCtrl);

    categoriesCtrl.$inject = ['$state', 'categoriesService', 'trackingService', 'wtNotifications',
        '$translate', '$stateParams', '$q'];

    function categoriesCtrl($state, categoriesService, trackingService, wtNotifications, $translate,
        $stateParams, $q) {
        var that = this;

        this.$onInit = function() {
            that.category = {
                name: '', desc: ''
            };

            if ($stateParams.categoryId) {
                return categoriesService.getCategory($stateParams.categoryId).then(function(category) {
                    that.category = category;
                });
            }
            return $q.resolve();
        };

        that.be_error = null;

        that.save = function save() {
            if (that.category.id) {
                trackingService.action('category.update');
                categoriesService.updateCategory(that.category)
                    .then(function(res) {
                        $state.go('main.categories.overview')
                            .then(() => {
                                wtNotifications.success(
                                    $translate.instant('CATEGORY_MSG_UPDATE_SUCCESS', {categoryName: res.name}, '', '')
                                );
                            });
                    })
                    .catch(function(err) {
                        if (_.has(err, 'message') && !_.isUndefined(err.message)) {
                            that.be_error = err.message.toUpperCase();
                            wtNotifications.error(err.message.toUpperCase());
                        }
                    });
            } else {
                trackingService.action('category.create');
                categoriesService.createCategory(that.category)
                    .then(function() {
                        $state.go('main.categories.overview')
                            .then(() => {
                                wtNotifications.success(
                                    $translate.instant('CATEGORY_MSG_CREATE_SUCCESS', {categoryName: that.category.name}, '', '')
                                );
                            });
                    })
                    .catch(function(err) {
                        if (_.has(err, 'message') && !_.isUndefined(err.message)) {
                            that.be_error = err.message.toUpperCase();
                            wtNotifications.error(err.message.toUpperCase());
                        }
                    });
            }
        };
    }
})(window.angular);
